import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

import { DuplicateIcon } from '@/shared/assets/icons/duplicate-icon';
import { MenuItem } from '@/shared/components/ui/menu-item/menu-item';
import { Can } from '@/shared/features/permissions/components/can/can';
import { DUPLICATE_FROM_PARAM } from '@/shared/features/rbac/components/duplicate-role/duplicate-role.constants';
import { TDuplicateRoleProps } from '@/shared/features/rbac/components/duplicate-role/duplicate-role.types';
import { useRbacConfig } from '@/shared/features/rbac/context/rbac-config-context';

export const DuplicateRole: React.FC<TDuplicateRoleProps> = ({
  role,
  onClose,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { permissionActions } = useRbacConfig();

  // Reached from the list (/roles) and from a role page (/roles/:id), so the
  // base path is whatever precedes the role id.
  const getRolesPath = () => pathname.split(`/${role.userRoleId}`)[0];

  const handleClick = () => {
    navigate(
      `${getRolesPath()}/new?${DUPLICATE_FROM_PARAM}=${role.userRoleId}`,
    );
    onClose?.();
  };

  return (
    <Can action={permissionActions.createUserRole}>
      <MenuItem icon={<DuplicateIcon />} onClick={handleClick}>
        {t('rbac:duplicate_role')}
      </MenuItem>
    </Can>
  );
};
